import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SectionRoot = styled(Box)(() => ({
    maxWidth: 960,
}));

export const SectionHeading = styled(Typography)(({ theme }) => ({
    fontSize: "1rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(3),
}));

export const FieldGrid = styled(Box)(() => ({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    columnGap: 48,
    rowGap: 20,
}));

/**
 * Wraps a field label and appends a red asterisk to mark the field as required.
 * Usage: <RequiredLabel>{t("myField")}</RequiredLabel>
 */
export const RequiredLabel = styled("span")(({ theme }) => ({
    "&::after": {
        content: '" *"',
        color: theme.palette.error.main,
        fontWeight: 700,
    },
}));
